export default __webpack_public_path__ + "static/media/portfolio-4.e1659cda.jpg";